import { render, staticRenderFns } from "./ErpSync.vue?vue&type=template&id=0533f967&"
import script from "./ErpSync.vue?vue&type=script&lang=js&"
export * from "./ErpSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports